<template>
    <div>
      <NavItem></NavItem>
      <Banner>
        <p slot="title">门店</p>
        <p slot="s-title">STORE</p>
    </Banner> 
      <div class="s-select" v-if="!userAgent">
        <div class="f-flex">
          <el-select v-model="value1" placeholder="选择省" @change="change_province()">
          <el-option
            v-for="(item, index) in province"
            :key="item.code"
            :label="item.label"
            :value="index"
          >
          </el-option>
        </el-select>
  
        <el-select 
          v-model="value2"
          collapse-tags
          style="margin-left: 20px;"
          placeholder="选择市" @change="change_city">
          <el-option
            v-for="(item, index) in city"
            :key="item.code"
            :label="item.label"
            :value="index"
          >
          </el-option>
        </el-select>
        <el-select @change="change_area"
          v-model="value3"
          collapse-tags
          style="margin-left: 20px;"
          placeholder="选择区/县"
        >
          <el-option
            v-for="(item, index) in area"
            :key="item.code"
            :label="item.label"
            :value="index"
          >
          </el-option>
        </el-select>
        </div>
        
        
      </div>
      <div class="s-select1" v-else>
        <el-select v-model="value1" placeholder="选择省" @change="change_province">
          <el-option
            v-for="(item, index) in province"
            :key="item.code"
            :label="item.label"
            :value="index"
          >
          </el-option>
        </el-select>
  
        <el-select @change="change_city"    
          v-model="value2" 
          collapse-tags
          style="margin-left: 20px;"
          placeholder="选择市"
        >
          <el-option
            v-for="(item, index) in city"
            :key="item.code"
            :label="item.label"
            :value="index"
          >
          </el-option>
        </el-select>
        <el-select @change="change_area"
          v-model="value3"
          collapse-tags
          style="margin-left: 20px;"
          placeholder="选择县、区"
        >
          <el-option
            v-for="(item, index) in area"
            :key="item.code"
            :label="item.label"
            :value="index"
          >
          </el-option>
        </el-select>
      </div>
      <div class="s-pos f-flex" v-if="!userAgent">
        <div class="s-pos-item" v-for="item of shops" :key="item.id">
            <p>{{item.name}}</p>
            <div>
              <img src="@/assets/images/pos.png" alt="">
              <span @click="handMap(item.lat,item.lng,item.name,item.address)">{{item.address}}</span>             
            </div>
            <div>
              <img src="@/assets/images/dianhua1.png" alt="">
              <a :href="'tel:'+item.tel">{{item.tel}}</a>
            </div>
            <div id="allmap">
              <baidu-map class="map" id="map" :center="{lng:item.lng,lat:item.lat}" :zoom="zoom" ref="allmap"
              :scroll-wheel-zoom="true"
              >            
                <bm-navigation anchor="BMAP_ANCHOR_BOTTOM_RIGHT" ></bm-navigation>
                <bml-marker-cluster :averageCenter="true">
                    <bm-marker  :position="{lng: item.lng, lat: item.lat}"></bm-marker>
                </bml-marker-cluster>
              </baidu-map>
            </div>
            
        </div>
      </div>
      <div class="s-pos1" v-else>
        <div class="s-pos-item1" v-for="item of shops" :key="item.id">
            <p>{{item.name}}</p>
            <div class="s-icon">
              <img src="@/assets/images/pos.png" alt="">
              <div>
                <p @click="handMap(item.lat,item.lng,item.name,item.address)">{{item.address}}</p>               
              </div>
            </div>
            <div>
              <img src="@/assets/images/dianhua1.png" alt="">
              <a :href="'tel:'+item.tel">{{item.tel}}</a>
            </div>
            <div id="allmap">
              <baidu-map class="map" id="map" :center="{lng:item.lng,lat:item.lat}" :zoom="zoom" ref="allmap"
              :scroll-wheel-zoom="true"
              >
              <bm-map-type :map-types="['BMAP_NORMAL_MAP', 'BMAP_SATELLITE_MAP']" anchor="BMAP_ANCHOR_TOP_LEFT"></bm-map-type>
                <bm-navigation anchor="BMAP_ANCHOR_BOTTOM_RIGHT" ></bm-navigation>
                <bml-marker-cluster  :averageCenter="true">
                    <bm-marker  :position="{lng: item.lng, lat: item.lat}"></bm-marker>
                </bml-marker-cluster>
              </baidu-map>
            </div>
        </div>       
      </div>

    </div>
</template>
  
  <script>
  import {MP} from '../../../map'
  // import {BmMarkerClusterer} from 'vue-baidu-map'
  export default {
    name: "Index",
    
    data() {     
      
      return {
        value1: '',
        value2: '',
        value3: '',
        input:'',
        province:[],
        city: [],
        area: [],
        shops:[],
        code:"",     
        zoom:12.8
      };
    },
    components:{
      // BmMarkerClusterer
    },
    methods: {
      change_province: function (name) {
        this.city = this.province[this.value1].pid;
        this.value2 = '';
        this.value3 = '';
        this.$http({
        url:'api/index/storesearch',
        method:"get",
        params:{
            province:this.province[this.value1].code
        }
      }).then(res=>{
        this.shops=res.data.data
      })
      },
      change_city: function () {
        this.area = this.city[this.value2].pid;
        this.value3 = '';
        this.$http({
        url:'api/index/storesearch',
        method:"get",
        params:{
            province:this.province[this.value1].code,
            city:this.city[this.value2].code
        }
      }).then(res=>{
        this.shops=res.data.data
      })
      },
      change_area: function () {
        this.$http({
        url:'api/index/storesearch',
        method:"get",
        params:{
            province:this.province[this.value1].code,
            city:this.city[this.value2].code,
            area:this.area[this.value3].code
        }
      }).then(res=>{
        this.shops=res.data.data
      })
    },
    handMap(lat,lng,name,address){
     window.location.href = `http://api.map.baidu.com/geocoder?location=${lat},${lng}&address=${address}&title=${name}&output=html&src=webapp.baidu.openAPIdemo `;

    },
    handleLocation(lng,lat){
      console.log(lng,lat)
    },
    
  },
    mounted(){
      this.$http.get('api/index/shoplevel').then(res=>{
        this.province=res.data.data;      
      })
      this.$http.get('api/index/storesearch').then(res=>{
        this.shops=res.data.data  
        // this.location.lng=this.shops[3].lng
        // this.location.lat=this.shops[3].lat
      })
    }

  };
  </script>
  
<style scoped>  
  .s-select{
     width:100%;
     min-height:80px;
     background-color: #F0F0F0;
  }
  .s-select>div{
    width: 80%;
    margin: 0 auto;
  }
  .s-select /deep/ .el-select{
    padding: 15px 0;
    width: 20%;
  }
  .s-search /deep/ .el-input{
    width: 80%;
    height: 100%;
    padding: 15px 0;
  }
  .s-search{
    height: 40px;
    width: 20%;
    margin-left: 10px;
    position: relative;
  }
  .s-search button{
    background-color: #DDDDDD;
    width:40px;
    height: 100%;
    border: none;
    position: absolute;
    top:15px ;
  }
  .s-search button img{
    width: 15px;
  }
  .s-pos{
    width: 80%;
    margin: 30px auto;
    flex-wrap: wrap;
  }
  .s-pos-item{
    width: 45%;
    padding:25px 0 ;
    border-top: 1px solid #cccccc;
    border-bottom: 1px solid #cccccc;
    margin-right:2%;
    cursor: pointer;
  }
  .s-pos-item p{
    font-size: 20px;
  }
  .s-pos-item div{
    margin: 2% 0;
    color:#989898;
    font-size: 13px;
  }
  .s-pos-item div>span{
    margin-right: 1%;
    margin-left: 1%;
    line-height: 20px;
  }

  .s-pos img{
    width: 18px;
  }
  .s-pos-item div>a{
    color:#989898 ;
    margin-left: 1%;
  }
  .el-select-dropdown.is-multiple .el-select-dropdown__item.selected,/deep/.el-tag.el-tag--info{
    color:#C94032 ;
  }
  /deep/.el-tag.el-tag--info{
    background:none;
    border: none;
  }
  .el-select-dropdown__item.selected,/deep/.el-input--suffix .el-input__inner {
    color: #C94032;
    font-weight: normal;
  }
  /deep/.el-select .el-input.is-focus .el-input__inner,/deep/.el-select .el-input__inner:focus{
    border-color: #C94032;
  }
  .el-select-dropdown__item.hover, .el-select-dropdown__item:hover{
    color: #C94032;
  }
  /* 移动端 */
  .s-select1{
     width:100%;
    padding:2% 0;
     background-color: #F0F0F0;
  }
  .s-select1 /deep/ .el-select{
    padding: 5px 0;
    width: 90%;
  }
  .s-select1 /deep/ .el-select:nth-child(1){
    padding: 5px 0;
    width: 90%;
    margin-left: 20px;
  }
  .s-search1 /deep/ .el-input{
    width: 80%;
    height: 100%;
    padding: 15px 0;
  }
  .s-search1{
    height: 40px;
    width: 95%;
    margin-left: 20px;
    position: relative;
  }
  .s-search1 button{
    background-color: #DDDDDD;
    width:40px;
    height: 100%;
    border: none;
    position: absolute;
    top:15px ;
  }
  .s-search1 button img{
    width: 15px;
  }

  .s-pos1{
    width:90%;
    margin: 2% auto;
    flex-wrap: wrap;
  }
  .s-pos1 p{
    font-size: 13px;
  }
  .s-pos-item1{
    width: 100%;
    padding:2% 0 3%;
    margin-bottom: 5%;
    border-bottom: 1px solid #cccccc;
    align-items: center;
  }
 
  .s-pos-item1 div{
    width: 100%;
    color:#989898;
    font-size: 12px;
  }
  .s-pos-item1 div>p{
    margin: 5% 0;
  }
   .s-pos-item1 div a{
     color:#989898 ;
   }
  .s-pos1 img{
    width: 18px;
    height: 20px;
    margin-right: 2%;
  }
.s-icon{
  align-items: center;
  display: flex;
}
.s-pos-item1 .s-icon>div{
  width: 100%;
}
.s-pos-item1 .s-icon>div p{
  line-height: 20px;
  width: 100%;
}
  </style>
  <style>
    .map{
      width: 100%;
      height: 240px;
      margin-top: 2%;
    }
  </style>
  